function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "116.9,55.5 127.2,55.5 122,32.3  "
}), React.createElement("path", {
  className: "st0",
  d: "M198.4,5.3H27.1c-11.5,0-20.8,9.3-20.8,20.8v44.2c0,11.5,9.3,20.8,20.8,20.8h171.3c11.5,0,20.8-9.3,20.8-20.8 V26.2C219.3,14.7,209.9,5.3,198.4,5.3z M44.1,80.3l-8.4-21.6l-8.4,21.6h-9.2l12.9-32.6L19.3,17.8h8.9l7.6,20.1l7.4-20.1h8.9 L40.4,48.1l12.9,32.2H44.1z M83.2,28.3H64.9v14.8h15.8v10.6H64.9v26.6h-7.6V17.8h26V28.3z M102.9,63.6H88.7v-12h14.3V63.6z  M133,80.3l-3.3-14.2h-15.1l-3.1,14.2h-8.1L118,17.8h8.1l15.2,62.5H133z M159.2,80.3h-8.2l-13.5-62.5h8.3l9.6,46.3l9.3-46.3h8.1 L159.2,80.3z M202.6,76.4c-2.6,3.3-6,5-10.1,5c-5,0-9.2-2.8-12.4-8.5s-4.9-13.4-4.9-23.3c0-10.4,1.6-18.5,4.9-24.2 c3.3-5.8,7.5-8.6,12.8-8.6c4.6,0,8.4,2.3,11.3,6.8c1.7,2.7,3,6.5,3.9,11.5l-7.6,3c-0.4-3.2-1.4-5.8-2.8-7.7 c-1.4-1.9-3.1-2.8-5.2-2.8c-2.8,0-5.1,1.7-6.8,5c-1.7,3.3-2.6,8.7-2.6,16.2c0,7.9,0.9,13.5,2.6,16.9c1.7,3.4,4,5,6.7,5 c2,0,3.8-1.1,5.2-3.2c1.5-2.1,2.5-5.5,3.1-10.1l7.4,3.9C207.2,68,205.3,73.1,202.6,76.4z"
}));

var SvgXfAvcIcon = function SvgXfAvcIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 225.5 98.8",
    style: {
      enableBackground: "new 0 0 225.5 98.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgXfAvcIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xf-avc-icon.df6f01e7.svg";
export { ForwardRef as ReactComponent };